import { useContext, useMemo } from "react";
import { AccountContext } from "../context/account";

export default function useIsSuperAdmin(): boolean {
  const { account } = useContext(AccountContext);

  return useMemo(() => {
    const isLoggedIn = !!(account?.checked && account?.loggedIn);
    return isLoggedIn && account?.level === 100;
  }, [account?.checked, account?.loggedIn, account?.level]);
}